//@ts-check
import React from 'react';
import moment from 'moment';
/**@type {import('../commonTypes').FormInputVariant & import('../commonTypes').FormInputDisabled & {schema: import('./types').EcrionFilterSchema} & {color: import('./types').FormInputFilterProps["color"]}} */

var defaultValue = {
  disabled: false,
  schema: null,
  variant: 'filled',
  color: 'primary'
};
var FilterContext = React.createContext(defaultValue);
export var useFilterContext = function useFilterContext() {
  return React.useContext(FilterContext);
};
/**
 * @param {import('./types').EcrionFilterSchema} schema
 * @param {string} field
 */

export var getFieldSchema = function getFieldSchema(schema, field) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = schema.Groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var group = _step.value;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = group.Fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var groupField = _step2.value;
          if (groupField.Name === field) return groupField;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};
/**
 * @param {import('./types').EcrionFilterFieldSchema} fieldSchema
 */

export var getFieldSchemaOperators = function getFieldSchemaOperators(fieldSchema) {
  /**@type {import('./types').EcrionFilterOperator[]} */
  var supportedOps = [];

  if (fieldSchema.Type === 'text') {
    if (fieldSchema.ValidationType === 'numeric') {
      supportedOps = ['Equal', 'NotEqual', 'Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual'];
    } else {
      supportedOps = ['Contains', 'StartsWith', 'EndsWith', 'Equal', 'NotEqual'];
    }
  } else if (fieldSchema.Type === 'selection') {
    supportedOps = ['Equal', 'NotEqual'];
  } else if (fieldSchema && (fieldSchema.Type === 'datetime' || fieldSchema.Type === 'date')) {
    supportedOps = ['DateBefore', 'DateAfter', 'DateEqual', 'DateNotEqual'];
  } else if (fieldSchema && fieldSchema.Type === 'time') {
    supportedOps = ['TimeBefore', 'TimeAfter', 'TimeEqual', 'TimeNotEqual'];
  } else {
    supportedOps = ['Equal'];
  }

  return supportedOps;
};
/**
 * @param {import('./types').EcrionFilterFieldSchema} fieldSchema
 */

export var getFieldSchemaDefaultValue = function getFieldSchemaDefaultValue(fieldSchema) {
  var defaultValue = '';

  if (fieldSchema.Type === 'text') {
    defaultValue = '';
  } else if (fieldSchema.Type === 'selection') {
    if (fieldSchema.Selection && fieldSchema.Selection.length) defaultValue = fieldSchema.Selection[0].Value;
  } else if (fieldSchema.Type === 'dialog') {
    if (fieldSchema.Name === 'Event') defaultValue = 'CATEGORY:CorrespondenceSubmittedEvent;COUNT-MIN:1';
  } else if (fieldSchema.Type === 'datetime' || fieldSchema.Type === 'date' || fieldSchema.Type === 'time') {
    defaultValue = moment().utc().format();
  }

  return defaultValue;
};
export default FilterContext;